import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function PatientNewFlowInsuranceEditConfirmModalTemplate({ patientNewFlowInsuranceEditConfirmModalStore , t}) {
    const {
        modalParams,
        onConfirm,
        isInactive
    } = patientNewFlowInsuranceEditConfirmModalStore;
    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>You are about to edit this patient's {isInactive ? "inactive" : "active"} insurance</h3>
            </div>
            <div className="modal__body">
                <p className='type--wgt--semibold'>This action should be done only if the policy number of the current {isInactive ? "inactive" : "active"} insurance is incorrect. If the patient has a new insurance policy, please add it as a new one.</p>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={t('EDIT_FORM_LAYOUT.CONTINUE')}
                    onClick={() => onConfirm()}
                />
            </div>
        </section>
    )
}
 
PatientNewFlowInsuranceEditConfirmModalTemplate.propTypes = {
    patientNewFlowInsuranceEditConfirmModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PatientNewFlowInsuranceEditConfirmModalTemplate);
